import type { Data } from '@angular/router';
import z from 'zod';
import { type ApplicationFeatureType, applicationFeatureType } from './permissions';

/**
 * The property in the route data for application features
 */
export const applicationFeatureKey = 'applicationFeatures';

/**
 * Fills the route data with application feature requirements
 * @param requiredFeatures The application features required to access the path
 */
export const withPermissions = (requiredFeatures: ApplicationFeatureType[]) => ({
  [applicationFeatureKey]: new Set(requiredFeatures)
});

/**
 * Checks if the user has application feature to access the path
 * Compares the application features required in the route data with the application features given
 * Only one application feature is required to match
 *
 * @param routeData The data property from the Router
 * @param userApplicationFeatures A set of permissions from the user
 */
export const hasPermission = (routeData: Data, userApplicationFeatures: Set<ApplicationFeatureType>): boolean => {
  const requiredApplicationFeatures = z.set(applicationFeatureType).parse(routeData[applicationFeatureKey]);

  if (
    requiredApplicationFeatures.size === 0 ||
    requiredApplicationFeatures.intersection(userApplicationFeatures).size > 0
  ) {
    return true;
  }

  return false;
};
